import { useSelector } from 'react-redux';
import { getDepartmentIcon, getSubdivisionIcon } from '../../global/utils/iconsUtils';
import "./ApplicationRow.css";

const ApplicationRow = ({ lineSupport, orangeText, redText, subdivisionUUID, departmentUUID }) => {
    const { icons } = useSelector(state => state.implementers);

    // Получаем иконку с приоритетом: custom subdivision -> department
    const icon = getSubdivisionIcon(subdivisionUUID, departmentUUID, icons) ||
        getDepartmentIcon(departmentUUID, icons);

    return (
        <div className="department_block">
            <div className="department_block_content">
                {icon && <img className="department_block_img" src={icon} alt={lineSupport} style={{ maxHeight: 30, maxWidth: 90 }} />}
                <span className="department_text">{lineSupport}</span>
            </div>
            <div className="departments dark-gray_color">
                <div className="departments_item">
                    <div className="department_header">
                        <div className="raunded bgOrange"></div>
                        <span className="department_header_text">{orangeText}</span>
                    </div>
                    <div className="department_header">
                        <div className="raunded bgRed"></div>
                        <span>{redText}</span>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ApplicationRow;